import React, { Component } from 'react'

import OrderTodayReadOnly from './today_delay'

/**
 * 只读
 */
export default class OrderList extends Component {

    render() {

        return (
            <OrderTodayReadOnly readOnly />
        )
    }
}